import React, { memo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { createSearchParams, useNavigate } from 'react-router-dom';
import Button from '../../../../components/Button';
import AppConfig from '../../../../config';
import './CloseCard.scss';
const { routes } = AppConfig;

const CloseCardFooter = memo(({ outsideParams }) => {
	const navigate = useNavigate();
	const { cardId } = outsideParams;
	const card = useSelector(store => store.card.cardsList.find(({ Id }) => Id === cardId));
	const isHasBalance = Boolean(card && card?.BalanceUsd > 0);
	const clickContinueHandler = useCallback(() => {
		navigate({
			pathname: isHasBalance ? routes.closeCardWithdraw : routes.closeCardConfirm,
			search: createSearchParams({ cardId }).toString(),
		});
	}, [isHasBalance, navigate, cardId]);
	return (
		<Button disabled={!card} onClick={clickContinueHandler}>
			Continue
		</Button>
	);
});

export default CloseCardFooter;
